// import React from "react";
// import { database, auth } from '../firebase.js';
// import { ref, push, set, onValue, off, serverTimestamp } from 'firebase/database';
// import { onAuthStateChanged } from 'firebase/auth';

// const GroupTable = () => {
//   const [groups, setGroups] = React.useState([]);
//   const [currentPage, setCurrentPage] = React.useState('table'); // 'table', 'addForm', 'editForm'
//   const [loading, setLoading] = React.useState(true);
//   const [currentUser, setCurrentUser] = React.useState(null);
//   const [editingGroup, setEditingGroup] = React.useState(null);
//   const [message, setMessage] = React.useState('');

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, '_');
//   };

//   // Validate group name - only letters, &, and parentheses
//   const validateGroupName = (name) => {
//     const regex = /^[a-zA-Z\s&()]+$/;
//     return regex.test(name.trim());
//   };

//   // Monitor authentication state
//   React.useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setCurrentUser(user);
//       } else {
//         setCurrentUser(null);
//         setGroups([]);
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   // Fetch groups from Realtime Database
//   React.useEffect(() => {
//     if (!currentUser) {
//       setLoading(false);
//       return;
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);

//     const handleData = (snapshot) => {
//       const groupsData = [];
//       snapshot.forEach((childSnapshot) => {
//         groupsData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val()
//         });
//       });
//       setGroups(groupsData);
//       setLoading(false);
//     };

//     const handleError = (error) => {
//       console.error("Error fetching groups: ", error);
//       setLoading(false);
//     };

//     onValue(groupsRef, handleData, handleError);

//     return () => {
//       off(groupsRef, 'value', handleData);
//     };
//   }, [currentUser]);

//   // Styles matching PurchaseBillTable
//   const styles = {
//     container: {
//       maxWidth: '100%',
//       margin: '0 auto',
//       padding: '2rem',
//       minHeight: '100vh',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '2rem',
//       padding: '1.5rem',
//       backgroundColor: 'white',
//       borderRadius: '6px',
//       border: '1px solid #d1d5db',
//       fontWeight: '600',
//       color: '#374151',
//     },
//     title: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       color: '#2563eb',
//       margin: '0',
//     },
//     addButton: {
//       padding: '0.875rem 2rem',
//       borderRadius: '8px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.95rem',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//     },
//     tableContainer: {
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       overflow: 'hidden',
//       boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
//       border: '1px solid #e2e8f0',
//       overflowX: 'auto',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.9rem',
//       border: '1px solid #d1d5db',
//     },
//     tableHeader: {
//       padding: '1rem 0.75rem',
//       textAlign: 'left',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.85rem',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       border: '1px solid #1e40af',
//     },
//     tableCell: {
//       padding: '1rem 0.75rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       verticalAlign: 'middle',
//       textAlign: 'left',
//     },
//     noData: {
//       textAlign: 'center',
//       padding: '4rem 2rem',
//       color: '#718096',
//       fontSize: '1.1rem',
//     },
//     srNoCell: {
//       fontWeight: '600',
//       textAlign: 'center',
//       width: '60px',
//     },
//     actionCell: {
//       display: 'flex',
//       gap: '0.5rem',
//       justifyContent: 'flex-start',
//       alignItems: 'center',
//       padding: '0.5rem',
//     },
//     editButton: {
//       padding: '0.5rem',
//       borderRadius: '6px',
//       backgroundColor: '#10b981',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
//       transform: 'translateY(0)',
//     },
//     deleteButton: {
//       padding: '0.5rem',
//       borderRadius: '6px',
//       backgroundColor: '#ef4444',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)',
//       transform: 'translateY(0)',
//     },
//     formContainer: {
//       padding: '2rem',
//     },
//     formLabel: {
//       display: 'block',
//       color: '#374151',
//       fontWeight: 'bold',
//       fontSize: '1.125rem',
//       marginBottom: '0.75rem',
//     },
//     formInput: {
//       width: '100%',
//       padding: '1rem 1.5rem',
//       fontSize: '1.125rem',
//       border: '2px solid #e5e7eb',
//       borderRadius: '0.75rem',
//       outline: 'none',
//       transition: 'border-color 0.2s',
//       boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//       boxSizing: 'border-box',
//     },
//     formHint: {
//       color: '#6b7280',
//       fontSize: '0.875rem',
//       marginTop: '0.5rem',
//       margin: '0.5rem 0 0 0',
//     },
//     message: {
//       marginTop: '1.5rem',
//       padding: '1rem',
//       borderRadius: '0.75rem',
//       fontWeight: '500',
//       fontSize: '1rem',
//     },
//     successMessage: {
//       backgroundColor: '#f0fdf4',
//       color: '#166534',
//       border: '2px solid #bbf7d0',
//     },
//     errorMessage: {
//       backgroundColor: '#fef2f2',
//       color: '#b91c1c',
//       border: '2px solid #fecaca',
//     },
//   };

//   const AddProductGroupPage = ({ editGroup = null }) => {
//     const [groupName, setGroupName] = React.useState(editGroup?.name || '');
//     const [message, setMessage] = React.useState('');

//     // Handle input change with validation
//     const handleGroupNameChange = (e) => {
//       const value = e.target.value;
//       // Allow only letters, &, and parentheses
//       const filteredValue = value.replace(/[^a-zA-Z\s&()]/g, '');
//       setGroupName(filteredValue);
//     };

//     const handleSave = () => {
//       const trimmedName = groupName.trim();
      
//       if (!trimmedName) {
//         setMessage('Group name cannot be empty!');
//         return;
//       }

//       if (!validateGroupName(trimmedName)) {
//         setMessage('Group name can only contain letters, spaces, "&", and parentheses!');
//         return;
//       }

//       if (!currentUser) {
//         setMessage('You must be logged in to add a product group');
//         return;
//       }

//       const encodedEmail = encodeEmailForPath(currentUser.email);

//       if (editGroup) {
//         // Edit existing group in Firebase
//         const groupRef = ref(database, `users/${encodedEmail}/productGroups/${editGroup.id}`);
//         set(groupRef, {
//           name: trimmedName,
//           createdAt: editGroup.createdAt,
//           createdBy: currentUser.email
//         })
//         .then(() => {
//           setMessage('Group name updated successfully!');
//           setTimeout(() => {
//             setCurrentPage('table');
//             setEditingGroup(null);
//             setMessage('');
//           }, 2000);
//         })
//         .catch((error) => {
//           setMessage('Error updating group name: ' + error.message);
//         });
//       } else {
//         // Add new group to Firebase
//         const newGroupRef = push(ref(database, `users/${encodedEmail}/productGroups`));
//         set(newGroupRef, {
//           name: trimmedName,
//           createdAt: serverTimestamp(),
//           createdBy: currentUser.email
//         })
//         .then(() => {
//           setMessage('Group name added successfully!');
//           setTimeout(() => {
//             setCurrentPage('table');
//             setEditingGroup(null);
//             setMessage('');
//           }, 2000);
//         })
//         .catch((error) => {
//           setMessage('Error saving group name: ' + error.message);
//         });
//       }
//     };

//     const handleCancel = () => {
//       setCurrentPage('table');
//       setEditingGroup(null);
//       setMessage('');
//     };

//     return (
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
//             <button
//               onClick={handleCancel}
//               style={{
//                 padding: '0.5rem',
//                 borderRadius: '0.5rem',
//                 border: 'none',
//                 backgroundColor: 'transparent',
//                 cursor: 'pointer',
//                 transition: 'background-color 0.2s',
//                 display: 'flex',
//                 alignItems: 'center'
//               }}
//               onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
//               onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               title="Back to Groups"
//             >
//               <svg style={{ width: '1.5rem', height: '1.5rem', color: '#6b7280' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
//               </svg>
//             </button>
//             <h1 style={styles.title}>
//               {editGroup ? 'Edit Product Group' : 'Add New Product Group'}
//             </h1>
//           </div>
//         </div>

//         <div style={styles.tableContainer}>
//           <div style={styles.formContainer}>
//             <h2 style={{
//               fontSize: '1.5rem',
//               fontWeight: 'bold',
//               color: '#2563eb',
//               marginBottom: '1rem'
//             }}>
//               Group Information
//             </h2>
            
//             <div style={{ maxWidth: '32rem' }}>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={styles.formLabel}>
//                   Group Name *
//                 </label>
//                 <input
//                   type="text"
//                   value={groupName}
//                   onChange={handleGroupNameChange}
//                   style={styles.formInput}
//                   onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
//                   onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
//                   placeholder="Enter group name "
//                 />
               
//               </div>
              
//               <div style={{ display: 'flex', gap: '1rem' }}>
//                 <button
//                   onClick={handleSave}
//                   style={styles.editButton}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = 'translateY(-2px)';
//                     e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = 'translateY(0)';
//                     e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
//                   }}
//                 >
//                   💾 {editGroup ? 'Update Group' : 'Save Group'}
//                 </button>
//                 <button
//                   onClick={handleCancel}
//                   style={{
//                     ...styles.editButton,
//                     backgroundColor: '#6b7280',
//                     boxShadow: '0 4px 15px rgba(107, 114, 128, 0.3)',
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = 'translateY(-2px)';
//                     e.target.style.boxShadow = '0 6px 20px rgba(107, 114, 128, 0.4)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = 'translateY(0)';
//                     e.target.style.boxShadow = '0 4px 15px rgba(107, 114, 128, 0.3)';
//                   }}
//                 >
//                   ❌ Cancel
//                 </button>
//               </div>
              
//               {message && (
//                 <div style={{
//                   ...styles.message,
//                   ...(message.includes('Error') || message.includes('cannot') || message.includes('can only') ? styles.errorMessage : styles.successMessage)
//                 }}>
//                   {message}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const handleEdit = (group) => {
//     setEditingGroup(group);
//     setCurrentPage('editForm');
//     setMessage('');
//   };

//   const handleDelete = (groupId) => {
//     if (window.confirm('Are you sure you want to delete this group?')) {
//       if (!currentUser) return;
      
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       const groupRef = ref(database, `users/${encodedEmail}/productGroups/${groupId}`);
      
//       set(groupRef, null)
//         .then(() => {
//           alert('Group deleted successfully!');
//         })
//         .catch((error) => {
//           alert('Error deleting group: ' + error.message);
//         });
//     }
//   };

//   if (currentPage === 'addForm') {
//     return <AddProductGroupPage />;
//   }

//   if (currentPage === 'editForm' && editingGroup) {
//     return <AddProductGroupPage editGroup={editingGroup} />;
//   }

//   if (!currentUser) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.noData}>
//           <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>🔐</div>
//           <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>Product Groups</h3>
//           <p>Please log in to view and manage your product groups.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h1 style={styles.title}>Product Groups</h1>
//         <button
//           onClick={() => setCurrentPage('addForm')}
//           style={styles.addButton}
//           onMouseEnter={(e) => {
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//           }}
//         >
//           + Add New Group
//         </button>
//       </div>

//       <div style={styles.tableContainer}>
//         {loading ? (
//           <div style={styles.noData}>
//             <p>⏳ Loading groups...</p>
//           </div>
//         ) : groups.length > 0 ? (
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={{ ...styles.tableHeader, ...styles.srNoCell }}>Sr.No</th>
//                 <th style={styles.tableHeader}>Group Name</th>
//                 <th style={styles.tableHeader}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {groups.map((group, index) => (
//                 <tr 
//                   key={group.id} 
//                   style={{
//                     backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
//                     transition: 'background-color 0.2s ease'
//                   }}
//                 >
//                   <td style={{ ...styles.tableCell, ...styles.srNoCell }}>{index + 1}</td>
//                   <td style={styles.tableCell}>{group.name}</td>
//                   <td style={{ ...styles.tableCell, ...styles.actionCell }}>
//                     <button
//                       onClick={() => handleEdit(group)}
//                       style={styles.editButton}
//                       title="Edit Group"
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-1px)';
//                         e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
//                       }}
//                     >
//                       ✏️
//                     </button>
//                     <button
//                       onClick={() => handleDelete(group.id)}
//                       style={styles.deleteButton}
//                       title="Delete Group"
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-1px)';
//                         e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
//                       }}
//                     >
//                       🗑️
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         ) : (
//           <div style={styles.noData}>
//             <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>📦</div>
//             <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>No Product Groups Found</h3>
//             <p style={{ marginBottom: '1.5rem' }}>Get started by adding your first product group!</p>
//             <button 
//               onClick={() => setCurrentPage('addForm')}
//               style={{
//                 ...styles.addButton,
//                 fontSize: '1rem',
//                 padding: '1rem 2rem'
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-2px)';
//                 e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//               }}
//             >
//               + Add Your First Group
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GroupTable;


import React from "react";
import { database, auth } from '../firebase.js';
import { ref, push, set, onValue, off, serverTimestamp } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';

const GroupTable = () => {
  const [groups, setGroups] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState('table'); // 'table', 'addForm', 'editForm'
  const [loading, setLoading] = React.useState(true);
  const [currentUser, setCurrentUser] = React.useState(null);
  const [editingGroup, setEditingGroup] = React.useState(null);
  const [message, setMessage] = React.useState('');

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, '_');
  };

  // Validate group name - only letters, &, and parentheses
  const validateGroupName = (name) => {
    const regex = /^[a-zA-Z\s&()]+$/;
    return regex.test(name.trim());
  };

  // Monitor authentication state
  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
        setGroups([]);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // Fetch groups from Realtime Database
  React.useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    const encodedEmail = encodeEmailForPath(currentUser.email);
    const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);

    const handleData = (snapshot) => {
      const groupsData = [];
      snapshot.forEach((childSnapshot) => {
        groupsData.push({
          id: childSnapshot.key,
          ...childSnapshot.val()
        });
      });
      setGroups(groupsData);
      setLoading(false);
    };

    const handleError = (error) => {
      console.error("Error fetching groups: ", error);
      setLoading(false);
    };

    onValue(groupsRef, handleData, handleError);

    return () => {
      off(groupsRef, 'value', handleData);
    };
  }, [currentUser]);

  // Styles matching PurchaseBillTable
  const styles = {
    container: {
      maxWidth: '100%',
      margin: '0 auto',
      padding: '2rem',
      minHeight: '100vh',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '2rem',
      padding: '1.5rem',
      backgroundColor: 'white',
      borderRadius: '6px',
      border: '1px solid #d1d5db',
      fontWeight: '600',
      color: '#374151',
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#2563eb',
      margin: '0',
    },
    addButton: {
      padding: '0.875rem 2rem',
      borderRadius: '8px',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.95rem',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
      transform: 'translateY(0)',
    },
    tableContainer: {
      backgroundColor: 'white',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      overflowX: 'auto',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.9rem',
      border: '1px solid #d1d5db',
    },
    tableHeader: {
      padding: '1rem 0.75rem',
      textAlign: 'left',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      fontSize: '0.85rem',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      border: '1px solid #1e40af',
    },
    tableCell: {
      padding: '1rem 0.75rem',
      border: '1px solid #d1d5db',
      color: '#374151',
      verticalAlign: 'middle',
      textAlign: 'left',
    },
    noData: {
      textAlign: 'center',
      padding: '4rem 2rem',
      color: '#718096',
      fontSize: '1.1rem',
    },
    srNoCell: {
      fontWeight: '600',
      textAlign: 'center',
      width: '60px',
    },
    actionCell: {
      display: 'flex',
      gap: '0.5rem',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '0.5rem',
    },
    editButton: {
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#10b981',
      color: 'white',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.8rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
      transform: 'translateY(0)',
    },
    deleteButton: {
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#ef4444',
      color: 'white',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.8rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)',
      transform: 'translateY(0)',
    },
    formContainer: {
      padding: '2rem',
    },
    formLabel: {
      display: 'block',
      color: '#374151',
      fontWeight: 'bold',
      fontSize: '1.125rem',
      marginBottom: '0.75rem',
    },
    formInput: {
      width: '100%',
      padding: '1rem 1.5rem',
      fontSize: '1.125rem',
      border: '2px solid #e5e7eb',
      borderRadius: '0.75rem',
      outline: 'none',
      transition: 'border-color 0.2s',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      boxSizing: 'border-box',
    },
    formHint: {
      color: '#6b7280',
      fontSize: '0.875rem',
      marginTop: '0.5rem',
      margin: '0.5rem 0 0 0',
    },
    message: {
      marginTop: '1.5rem',
      padding: '1rem',
      borderRadius: '0.75rem',
      fontWeight: '500',
      fontSize: '1rem',
    },
    successMessage: {
      backgroundColor: '#f0fdf4',
      color: '#166534',
      border: '2px solid #bbf7d0',
    },
    errorMessage: {
      backgroundColor: '#fef2f2',
      color: '#b91c1c',
      border: '2px solid #fecaca',
    },
  };

  const AddProductGroupPage = ({ editGroup = null }) => {
    const [groupName, setGroupName] = React.useState(editGroup?.name || '');
    const [message, setMessage] = React.useState('');

    // Handle input change with validation
    const handleGroupNameChange = (e) => {
      const value = e.target.value;
      // Allow only letters, &, and parentheses
      const filteredValue = value.replace(/[^a-zA-Z\s&()]/g, '');
      setGroupName(filteredValue);
    };

    const handleSave = () => {
      const trimmedName = groupName.trim();
      
      if (!trimmedName) {
        setMessage('Group name cannot be empty!');
        return;
      }

      if (!validateGroupName(trimmedName)) {
        setMessage('Group name can only contain letters, spaces, "&", and parentheses!');
        return;
      }

      if (!currentUser) {
        setMessage('You must be logged in to add a product group');
        return;
      }

      const encodedEmail = encodeEmailForPath(currentUser.email);

      if (editGroup) {
        // Edit existing group in Firebase
        const groupRef = ref(database, `users/${encodedEmail}/productGroups/${editGroup.id}`);
        set(groupRef, {
          name: trimmedName,
          createdAt: editGroup.createdAt,
          createdBy: currentUser.email
        })
        .then(() => {
          alert('Group name updated successfully!');
          setCurrentPage('table');
          setEditingGroup(null);
          setMessage('');
        })
        .catch((error) => {
          alert('Error updating group name: ' + error.message);
        });
      } else {
        // Add new group to Firebase
        const newGroupRef = push(ref(database, `users/${encodedEmail}/productGroups`));
        set(newGroupRef, {
          name: trimmedName,
          createdAt: serverTimestamp(),
          createdBy: currentUser.email
        })
        .then(() => {
          alert('Group name added successfully!');
          setCurrentPage('table');
          setEditingGroup(null);
          setMessage('');
        })
        .catch((error) => {
          alert('Error saving group name: ' + error.message);
        });
      }
    };

    const handleCancel = () => {
      setCurrentPage('table');
      setEditingGroup(null);
      setMessage('');
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button
              onClick={handleCancel}
              style={{
                padding: '0.5rem',
                borderRadius: '0.5rem',
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                display: 'flex',
                alignItems: 'center'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              title="Back to Groups"
            >
              <svg style={{ width: '1.5rem', height: '1.5rem', color: '#6b7280' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <h1 style={styles.title}>
              {editGroup ? 'Edit Product Group' : 'Add New Product Group'}
            </h1>
          </div>
        </div>

        <div style={styles.tableContainer}>
          <div style={styles.formContainer}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#2563eb',
              marginBottom: '1rem'
            }}>
              Group Information
            </h2>
            
            <div style={{ maxWidth: '32rem' }}>
              <div style={{ marginBottom: '2rem' }}>
                <label style={styles.formLabel}>
                  Group Name *
                </label>
                <input
                  type="text"
                  value={groupName}
                  onChange={handleGroupNameChange}
                  style={styles.formInput}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  placeholder="Enter group name "
                />
               
              </div>
              
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  onClick={handleSave}
                  style={styles.editButton}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
                  }}
                >
                  💾 {editGroup ? 'Update Group' : 'Save Group'}
                </button>
                <button
                  onClick={handleCancel}
                  style={{
                    ...styles.editButton,
                    backgroundColor: '#6b7280',
                    boxShadow: '0 4px 15px rgba(107, 114, 128, 0.3)',
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(107, 114, 128, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(107, 114, 128, 0.3)';
                  }}
                >
                  ❌ Cancel
                </button>
              </div>
              
              {message && (
                <div style={{
                  ...styles.message,
                  ...(message.includes('Error') || message.includes('cannot') || message.includes('can only') ? styles.errorMessage : styles.successMessage)
                }}>
                  {message}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleEdit = (group) => {
    setEditingGroup(group);
    setCurrentPage('editForm');
    setMessage('');
  };

  const handleDelete = (groupId) => {
    if (window.confirm('Are you sure you want to delete this group?')) {
      if (!currentUser) return;
      
      const encodedEmail = encodeEmailForPath(currentUser.email);
      const groupRef = ref(database, `users/${encodedEmail}/productGroups/${groupId}`);
      
      set(groupRef, null)
        .then(() => {
          alert('Group deleted successfully!');
        })
        .catch((error) => {
          alert('Error deleting group: ' + error.message);
        });
    }
  };

  if (currentPage === 'addForm') {
    return <AddProductGroupPage />;
  }

  if (currentPage === 'editForm' && editingGroup) {
    return <AddProductGroupPage editGroup={editingGroup} />;
  }

  if (!currentUser) {
    return (
      <div style={styles.container}>
        <div style={styles.noData}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>🔐</div>
          <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>Product Groups</h3>
          <p>Please log in to view and manage your product groups.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Product Groups</h1>
        <button
          onClick={() => setCurrentPage('addForm')}
          style={styles.addButton}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
          }}
        >
          + Add New Group
        </button>
      </div>

      <div style={styles.tableContainer}>
        {loading ? (
          <div style={styles.noData}>
            <p>⏳ Loading groups...</p>
          </div>
        ) : groups.length > 0 ? (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.tableHeader, ...styles.srNoCell }}>Sr.No</th>
                <th style={styles.tableHeader}>Group Name</th>
                <th style={styles.tableHeader}>Action</th>
              </tr>
            </thead>
            <tbody>
              {groups.map((group, index) => (
                <tr 
                  key={group.id} 
                  style={{
                    backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  <td style={{ ...styles.tableCell, ...styles.srNoCell }}>{index + 1}</td>
                  <td style={styles.tableCell}>{group.name}</td>
                  <td style={{ ...styles.tableCell, ...styles.actionCell }}>
                    <button
                      onClick={() => handleEdit(group)}
                      style={styles.editButton}
                      title="Edit Group"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
                      }}
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDelete(group.id)}
                      style={styles.deleteButton}
                      title="Delete Group"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
                      }}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div style={styles.noData}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>📦</div>
            <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>No Product Groups Found</h3>
            <p style={{ marginBottom: '1.5rem' }}>Get started by adding your first product group!</p>
            <button 
              onClick={() => setCurrentPage('addForm')}
              style={{
                ...styles.addButton,
                fontSize: '1rem',
                padding: '1rem 2rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
              }}
            >
              + Add Your First Group
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupTable;